import {
    openapiProxySessionProgramLoginRequest,
    OpenapiProxySessionProgramLoginResponse200Type,
} from 'src_common/server/openapi_proxy_session_program_login';
import { fetchWithRetry } from 'src_common/server/utils/fetchUtils';

export const createProgramSession = async (
    API_URL: string,
    API_TIMEOUT: number,
    API_USER: string,
    API_PASSWORD: string
): Promise<null | OpenapiProxySessionProgramLoginResponse200Type> => {
    const response = await fetchWithRetry(
        () =>
            openapiProxySessionProgramLoginRequest(API_URL, API_TIMEOUT, 'empty', {
                requestBody: {
                    username: API_USER,
                    password: API_PASSWORD,
                },
            }),
        {
            retries: 4,
            delay: 500,
            shouldRetry: (response) => response.status === 404 || response.status >= 500,
        }
    );

    if (response.status === 200) {
        return response.body;
    }

    console.error('Errors when creating an program session', response);

    return null;
};
